import React from "react";
import Select from "react-select";
import AsteriskSymbol from "../../components/reusableComponents/AsteriskSymbol";

const KSelect = (props) => {
    const {options, value, placeholder, onChange, label, isDisabled, isRequired} = props;
  return (
    <div className="form-group">
      <label for={`select-${label}`}>{label} {isRequired && <AsteriskSymbol />}</label>
      <Select
        id={`select-${label}`}
        options={options}
        onInputChange={(inputValue) => {
          // Replace non-alphanumeric characters
          const cleanedValue = inputValue.replace(/[^A-Za-z]/g, "");
          return cleanedValue; // Return cleaned value for the Select component
        }}
        classNamePrefix="bg-gray"
        className="fixed-height-select"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        isClearable={true}
        isDisabled={isDisabled}
      />
    </div>
  );
};

export default KSelect;
